import { getConditionalItem } from '@lemonade-hq/chat-wizard-client-base';
import { useI18nContext } from '@lemonade-hq/nuiza';
import type { SchemaData } from '@lemonade-hq/ts-helpers';
import type { UniclientFrame, UniclientStep } from '@lemonade-hq/uniclient-chat';
import { useMemo } from 'react';
import type { WizardExtendedStepWithPersistenceAndId } from '../persistence/wizard_persistence.context';
import { getMappedInterpolation } from '../utils/getMappedInterpolation';

export interface WizardStep {
  readonly name: string;
  readonly id: string;
  readonly frame?: UniclientFrame;
  readonly output: string;
}

interface UseWizardResolvedSteps {
  readonly steps: WizardExtendedStepWithPersistenceAndId<UniclientStep>[];
  readonly answers: SchemaData;
}

export const useWizardResolvedSteps = ({ steps, answers }: UseWizardResolvedSteps): WizardStep[] => {
  const i18nContext = useI18nContext();

  const resolvedSteps = useMemo(
    () =>
      steps.map<WizardStep>(step => {
        const frame = getConditionalItem(step.presentation.frame, answers);

        return {
          name: step.name,
          id: step.id,
          frame,
          output: getMappedInterpolation(step.data?.output, answers, i18nContext),
        };
      }),
    [answers, steps, i18nContext],
  );

  return resolvedSteps;
};
